import { useEffect, useState } from "react";
import { CURRENT_YEAR } from "@/lib/constants";

const KEY = "ynavi_kpi_year";
const EVT = "ynavi-year-change";

export function useGlobalYear(initial) {
  const [year, setYearState] = useState(() => initial || localStorage.getItem(KEY) || String(CURRENT_YEAR));
  useEffect(() => {
    const sync = () => setYearState(localStorage.getItem(KEY) || String(CURRENT_YEAR));
    window.addEventListener(EVT, sync); window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVT, sync); window.removeEventListener("storage", sync); };
  }, []);
  const setYear = (y) => { const v = String(y); localStorage.setItem(KEY, v); setYearState(v); window.dispatchEvent(new Event(EVT)); };
  useEffect(() => { if (initial) setYear(initial); }, []); // eslint-disable-line
  return [year, setYear];
}
